import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { EXPORT_DOWNLOAD_ERROR_MAP } from './constants';
import { StarterDashboardV2ExportedDownloadById } from './exportedDownloadById.graphql';
import type {
	StarterDashboardV2ExportedDownloadByIdExportedDownloadFieldsFragment,
	StarterDashboardV2ExportedDownloadByIdQuery,
	StarterDashboardV2ExportedDownloadByIdQueryVariables,
} from './exportedDownloadById.graphql';

export type ExportedDownload = StarterDashboardV2ExportedDownloadByIdExportedDownloadFieldsFragment;
type GetDownloadExportUrlParams = { downloadId: string };

export async function getDownloadExportUrl(
	{ downloadId }: GetDownloadExportUrlParams,
	{ errorReporter, gql: { fetch } }: UtilityContext,
): Promise<ExportedDownload> {
	const { data, requestId } = await fetch<
		StarterDashboardV2ExportedDownloadByIdQuery,
		StarterDashboardV2ExportedDownloadByIdQueryVariables
	>({
		query: StarterDashboardV2ExportedDownloadById,
		variables: { exportedDownloadByIdId: downloadId },
		rejectOnError: true,
	});

	if (data.exportedDownloadById.__typename === 'ExportedDownloadError') {
		void errorReporter.report({
			error: new Error('Failed to export signatures'),
			context: {
				requestId,
				reason: data.exportedDownloadById.status,
			},
		});
		throw new Error(EXPORT_DOWNLOAD_ERROR_MAP[data.exportedDownloadById.status].code, {
			cause: EXPORT_DOWNLOAD_ERROR_MAP[data.exportedDownloadById.status].message,
		});
	}

	return { url: data.exportedDownloadById.url, id: data.exportedDownloadById.id };
}
